import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  const userData = JSON.parse(localStorage.getItem("userData"));

  return userData ? children : <Navigate to="/" replace />;
};

export default PrivateRoute;
